export default "__VITE_ASSET__BO8ThmQn__"